var items = {
  "block.minecraft.air": "locht",
  "block.minecraft.stone": "stein",
  "block.minecraft.granite": "graniet",
  "block.minecraft.polished_granite": "gepolijste graniet",
  "block.minecraft.diorite": "dioriet",
  "block.minecraft.polished_diorite": "gepolijste dioriet",
  "block.minecraft.andesite": "andesiet",
  "block.minecraft.polished_andesite": "gepolijste andesiet",
  "block.minecraft.grass_block": "graasblok",
  "block.minecraft.dirt": "drek",
  "block.minecraft.coarse_dirt": "grovve drek",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "helroede nylium",
  "block.minecraft.warped_nylium": "spoekachtig nylium",
  "block.minecraft.cobblestone": "keij",
  "block.minecraft.oak_planks": "eikenhouten plenk",
  "block.minecraft.spruce_planks": "sparrenhouten plenk",
  "block.minecraft.birch_planks": "berkenhouten plenk",
  "block.minecraft.jungle_planks": "oerwoudhouten plenk",
  "block.minecraft.acacia_planks": "acaciahouten plenk",
  "block.minecraft.dark_oak_planks": "donkereikenhouten plenk",
  "block.minecraft.crimson_planks": "helroede houten plenk",
  "block.minecraft.warped_planks": "spoekachtige houten plenk",
  "block.minecraft.oak_sapling": "eikenkiemplant",
  "block.minecraft.spruce_sapling": "sparrenkiemplant",
  "block.minecraft.birch_sapling": "berkenkiemplant",
  "block.minecraft.jungle_sapling": "oerwoudkiemplant",
  "block.minecraft.acacia_sapling": "acaciakiemplant",
  "block.minecraft.dark_oak_sapling": "donkere eikenkiemplant",
  "block.minecraft.bedrock": "fondsjtein",
  "block.minecraft.sand": "zandj",
  "block.minecraft.red_sand": "roed zandj",
  "block.minecraft.gravel": "grind",
  "block.minecraft.gold_ore": "gouderts",
  "block.minecraft.iron_ore": "iezererts",
  "block.minecraft.coal_ore": "sjteinkoolerts",
  "block.minecraft.nether_gold_ore": "nethergolderts",
  "block.minecraft.oak_log": "eikenstjam",
  "block.minecraft.spruce_log": "sparrenstjam",
  "block.minecraft.birch_log": "berkenstjam",
  "block.minecraft.jungle_log": "oerwoudstam",
  "block.minecraft.acacia_log": "acaciastjam",
  "block.minecraft.dark_oak_log": "donkereeikenhoutensjtam",
  "block.minecraft.crimson_stem": "helroede stem",
  "block.minecraft.warped_stem": "spoekachtige stem",
  "block.minecraft.stripped_oak_log": "gestripte eikesjtam",
  "block.minecraft.stripped_spruce_log": "gestripte sjparresjtam",
  "block.minecraft.stripped_birch_log": "gestripte berkesjtam",
  "block.minecraft.stripped_jungle_log": "gestripte oerwoudsjtam",
  "block.minecraft.stripped_acacia_log": "gestripte acaciasjtam",
  "block.minecraft.stripped_dark_oak_log": "gestripte donkere eikensjtam",
  "block.minecraft.stripped_crimson_stem": "gestripte helroede stem",
  "block.minecraft.stripped_warped_stem": "gestripte spoekachtige stem",
  "block.minecraft.stripped_oak_wood": "gestript eikehout",
  "block.minecraft.stripped_spruce_wood": "gestript sjparrehout",
  "block.minecraft.stripped_birch_wood": "gestript berkehout",
  "block.minecraft.stripped_jungle_wood": "gestript oerwoudhout",
  "block.minecraft.stripped_acacia_wood": "gestript acaciahout",
  "block.minecraft.stripped_dark_oak_wood": "gestript donkereikehout",
  "block.minecraft.stripped_crimson_hyphae": "gestripte helroede schimmeldraod",
  "block.minecraft.stripped_warped_hyphae": "gestripte spoekachtige schimmeldraod",
  "block.minecraft.oak_wood": "eikehout",
  "block.minecraft.spruce_wood": "sjparrehout",
  "block.minecraft.birch_wood": "birkehout",
  "block.minecraft.jungle_wood": "oerwoudhout",
  "block.minecraft.acacia_wood": "acaciahout",
  "block.minecraft.dark_oak_wood": "donker eikehout",
  "block.minecraft.crimson_hyphae": "helroede schimmeldraod",
  "block.minecraft.warped_hyphae": "spoekachtige schimmeldraod",
  "block.minecraft.oak_leaves": "eikenblajere",
  "block.minecraft.spruce_leaves": "sparrennaoldje",
  "block.minecraft.birch_leaves": "bérkenblajere",
  "block.minecraft.jungle_leaves": "oerwoudblajere",
  "block.minecraft.acacia_leaves": "acaciablajere",
  "block.minecraft.dark_oak_leaves": "dónkere eikenblajere",
  "block.minecraft.sponge": "sjpóns",
  "block.minecraft.wet_sponge": "natte sjpons",
  "block.minecraft.glass": "glaas",
  "block.minecraft.lapis_ore": "lapis lazuli-erts",
  "block.minecraft.lapis_block": "lapis lazuliblok",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "zandstein",
  "block.minecraft.chiseled_sandstone": "gebietelde zandstein",
  "block.minecraft.cut_sandstone": "gesneeje zandstein",
  "block.minecraft.note_block": "nootblok",
  "block.minecraft.powered_rail": "aandrijfspoear",
  "block.minecraft.detector_rail": "detectiespoear",
  "block.minecraft.sticky_piston": "kleefzuiger",
  "block.minecraft.cobweb": "spinneweb",
  "block.minecraft.grass": "graas",
  "block.minecraft.fern": "varen",
  "block.minecraft.dead_bush": "doeje stroek",
  "block.minecraft.seagrass": "ziëgraas",
  "block.minecraft.sea_pickle": "ziëaugurk",
  "block.minecraft.piston": "zuiger",
  "block.minecraft.white_wool": "witte wol",
  "block.minecraft.orange_wool": "oranje wol",
  "block.minecraft.magenta_wool": "magenta wol",
  "block.minecraft.light_blue_wool": "leechtblauwe wol",
  "block.minecraft.yellow_wool": "gaele wol",
  "block.minecraft.lime_wool": "limoengreune wol",
  "block.minecraft.pink_wool": "roze wol",
  "block.minecraft.gray_wool": "grieze wol",
  "block.minecraft.light_gray_wool": "leechtgrieze wol",
  "block.minecraft.cyan_wool": "turquoise wol",
  "block.minecraft.purple_wool": "paarse wol",
  "block.minecraft.blue_wool": "blauwe wol",
  "block.minecraft.brown_wool": "broene wol",
  "block.minecraft.green_wool": "greune wol",
  "block.minecraft.red_wool": "roeje wol",
  "block.minecraft.black_wool": "zjwarte wol",
  "block.minecraft.dandelion": "paerdebloom",
  "block.minecraft.poppy": "klaproeas",
  "block.minecraft.blue_orchid": "blauwe orchidee",
  "block.minecraft.allium": "look",
  "block.minecraft.azure_bluet": "porseleinsterretje",
  "block.minecraft.red_tulip": "roede tulp",
  "block.minecraft.orange_tulip": "oranje tulp",
  "block.minecraft.white_tulip": "witte tulp",
  "block.minecraft.pink_tulip": "roze tulp",
  "block.minecraft.oxeye_daisy": "margriet",
  "block.minecraft.cornflower": "korenbloom",
  "block.minecraft.lily_of_the_valley": "lelietje-van-dalen",
  "block.minecraft.wither_rose": "witherroes",
  "block.minecraft.brown_mushroom": "broene paddenstoel",
  "block.minecraft.red_mushroom": "roeje paddesjtool",
  "block.minecraft.crimson_fungus": "helroede zwam",
  "block.minecraft.warped_fungus": "spoekachtige zwam",
  "block.minecraft.crimson_roots": "helroede wortelle",
  "block.minecraft.warped_roots": "spoekachtige wortelle",
  "block.minecraft.nether_sprouts": "netherscheut'n",
  "block.minecraft.weeping_vines": "hangende lianen",
  "block.minecraft.twisting_vines": "dreiende lianen",
  "block.minecraft.sugar_cane": "soekër sjtek",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboe",
  "block.minecraft.gold_block": "goudblok",
  "block.minecraft.iron_block": "iezerblok",
  "block.minecraft.oak_slab": "eikenhouten plaat",
  "block.minecraft.spruce_slab": "sparrenhouten plaat",
  "block.minecraft.birch_slab": "berkenhouten plaat",
  "block.minecraft.jungle_slab": "oerwoudhouten plaat",
  "block.minecraft.acacia_slab": "acacia plaat",
  "block.minecraft.dark_oak_slab": "donkereeikenhouten plaat",
  "block.minecraft.crimson_slab": "helroede houten plaat",
  "block.minecraft.warped_slab": "spoekachtige houten plaat",
  "block.minecraft.stone_slab": "steinen plaat",
  "block.minecraft.smooth_stone_slab": "gladde steine plaat",
  "block.minecraft.sandstone_slab": "zandsteine plaat",
  "block.minecraft.cut_sandstone_slab": "gesneeje zandsteine plaat",
  "block.minecraft.petrified_oak_slab": "verstjeende eikenhouten plaat",
  "block.minecraft.cobblestone_slab": "keijplaat",
  "block.minecraft.brick_slab": "bakstein plaat",
  "block.minecraft.stone_brick_slab": "blokstein plaat",
  "block.minecraft.nether_brick_slab": "netherbakstein plaat",
  "block.minecraft.quartz_slab": "kwartsplaat",
  "block.minecraft.red_sandstone_slab": "roeje zandsteine plaat",
  "block.minecraft.cut_red_sandstone_slab": "gesneeje roeje zandsteine plaat",
  "block.minecraft.purpur_slab": "purpurplaat",
  "block.minecraft.prismarine_slab": "prismarine plaat",
  "block.minecraft.prismarine_brick_slab": "prismarienbakstein plaat",
  "block.minecraft.dark_prismarine_slab": "donkere prismarine plaat",
  "block.minecraft.smooth_quartz": "gladde kwartsblok",
  "block.minecraft.smooth_red_sandstone": "gladde roeje zandstein",
  "block.minecraft.smooth_sandstone": "gladde zandstein",
  "block.minecraft.smooth_stone": "gladde stein",
  "block.minecraft.bricks": "baksteinen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bokekas",
  "block.minecraft.mossy_cobblestone": "mossige keijstein",
  "block.minecraft.obsidian": "obsidiaan",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endstaaf",
  "block.minecraft.chorus_plant": "chorusplant",
  "block.minecraft.chorus_flower": "chorusbloom",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpurpillaar",
  "block.minecraft.purpur_stairs": "purpur traeje",
  "block.minecraft.spawner": "monsterkooi",
  "block.minecraft.oak_stairs": "eikehoute traeje",
  "block.minecraft.chest": "kis",
  "block.minecraft.diamond_ore": "diamanterts",
  "block.minecraft.diamond_block": "diamantblok",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "akkerlandj",
  "block.minecraft.furnace": "aove",
  "block.minecraft.ladder": "lèdder",
  "block.minecraft.rail": "rail",
  "block.minecraft.cobblestone_stairs": "keijstein traeje",
  "block.minecraft.lever": "hendel",
  "block.minecraft.stone_pressure_plate": "steinen drukplaat",
  "block.minecraft.oak_pressure_plate": "eikehoute drukplaat",
  "block.minecraft.spruce_pressure_plate": "sjparrehoute drukplaat",
  "block.minecraft.birch_pressure_plate": "berkehoute drukplaat",
  "block.minecraft.jungle_pressure_plate": "oerwoudhoute drukplaat",
  "block.minecraft.acacia_pressure_plate": "acacia drukplaat",
  "block.minecraft.dark_oak_pressure_plate": "donkere eikehoute drukplaat",
  "block.minecraft.crimson_pressure_plate": "helroede houten drukplaat",
  "block.minecraft.warped_pressure_plate": "spoekachtige houten drukplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "gepolieste zwartstein drukplaat",
  "block.minecraft.redstone_ore": "redstone-erts",
  "block.minecraft.redstone_torch": "redstone fakkel",
  "block.minecraft.snow": "sjnie",
  "block.minecraft.ice": "ies",
  "block.minecraft.snow_block": "snie blok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "kleij",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "eikenhouten hek",
  "block.minecraft.spruce_fence": "sparrenhouten hek",
  "block.minecraft.birch_fence": "berkenhouten hek",
  "block.minecraft.jungle_fence": "oerwoudhouten hek",
  "block.minecraft.acacia_fence": "acaciahouten hek",
  "block.minecraft.dark_oak_fence": "dónkere eikenhouten hek",
  "block.minecraft.crimson_fence": "helroede houten hek",
  "block.minecraft.warped_fence": "spoekachtige houten hek",
  "block.minecraft.pumpkin": "pompoen",
  "block.minecraft.carved_pumpkin": "gesjneeje pompoen",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "zeelzandj",
  "block.minecraft.soul_soil": "zielenaarde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "gepolieste basalt",
  "block.minecraft.soul_torch": "zeielenfakkel",
  "block.minecraft.glowstone": "gloeistein",
  "block.minecraft.jack_o_lantern": "jack-o'-lantern",
  "block.minecraft.oak_trapdoor": "eikhouten valloek",
  "block.minecraft.spruce_trapdoor": "sparrehouten valloek",
  "block.minecraft.birch_trapdoor": "berkehouten valloek",
  "block.minecraft.jungle_trapdoor": "oerwoudhouten valloek",
  "block.minecraft.acacia_trapdoor": "acaciahouten valloek",
  "block.minecraft.dark_oak_trapdoor": "donkereikenhouten valloek",
  "block.minecraft.crimson_trapdoor": "helroede houten valloek",
  "block.minecraft.warped_trapdoor": "spoekachtig houten valloek",
  "block.minecraft.infested_stone": "geïnfecteerde sjtein",
  "block.minecraft.infested_cobblestone": "geïnfecteerde kiezelsjtein",
  "block.minecraft.infested_stone_bricks": "geïnfecteerde bloksteinen",
  "block.minecraft.infested_mossy_stone_bricks": "geïnfecteerde mossige bloksteinen",
  "block.minecraft.infested_cracked_stone_bricks": "geïnfecteerde gebarste bloksteinen",
  "block.minecraft.infested_chiseled_stone_bricks": "geïnfecteerde gebietelde bloksteinen",
  "block.minecraft.stone_bricks": "bloksteinen",
  "block.minecraft.mossy_stone_bricks": "mossige bloksteinen",
  "block.minecraft.cracked_stone_bricks": "gebarste bloksteinen",
  "block.minecraft.chiseled_stone_bricks": "gebietelde bloksteinen",
  "block.minecraft.brown_mushroom_block": "broen paddenstoelenblok",
  "block.minecraft.red_mushroom_block": "roed paddenstoelenblok",
  "block.minecraft.mushroom_stem": "paddenstoelensjtam",
  "block.minecraft.iron_bars": "iezer stave",
  "block.minecraft.chain": "ketting",
  "block.minecraft.glass_pane": "glazen roet",
  "block.minecraft.melon": "meloen",
  "block.minecraft.vine": "lianen",
  "block.minecraft.oak_fence_gate": "eikenhouten peurtje",
  "block.minecraft.spruce_fence_gate": "sparrenhouten peurtje",
  "block.minecraft.birch_fence_gate": "berkenhouten peurtje",
  "block.minecraft.jungle_fence_gate": "oerwoudhouten peurtje",
  "block.minecraft.acacia_fence_gate": "acaciahouten peurtje",
  "block.minecraft.dark_oak_fence_gate": "donkere eikenhouten peurtje",
  "block.minecraft.crimson_fence_gate": "helroede houten peurtje",
  "block.minecraft.warped_fence_gate": "spoekachtig houten peurtje",
  "block.minecraft.brick_stairs": "bakstein traeje",
  "block.minecraft.stone_brick_stairs": "blokstein traeje",
  "block.minecraft.mycelium": "zwamvlok",
  "block.minecraft.lily_pad": "waterlelie",
  "block.minecraft.nether_bricks": "netherbakstein",
  "block.minecraft.cracked_nether_bricks": "gebarste netherbakstein",
  "block.minecraft.chiseled_nether_bricks": "gebietelde netherbakstein",
  "block.minecraft.nether_brick_fence": "netherbaksteinen hek",
  "block.minecraft.nether_brick_stairs": "netherbakstein traeje",
  "block.minecraft.enchanting_table": "betouvertaofel",
  "block.minecraft.end_portal_frame": "endportaalframe",
  "block.minecraft.end_stone": "endstein",
  "block.minecraft.end_stone_bricks": "endbloksteinen",
  "block.minecraft.dragon_egg": "drakenei",
  "block.minecraft.redstone_lamp": "redstonelamp",
  "block.minecraft.sandstone_stairs": "zandstein traeje",
  "block.minecraft.emerald_ore": "smaragderts",
  "block.minecraft.ender_chest": "enderkis",
  "block.minecraft.tripwire_hook": "stroekeldraodhaak",
  "block.minecraft.emerald_block": "smaragdblok",
  "block.minecraft.spruce_stairs": "sparrenhoute traeje",
  "block.minecraft.birch_stairs": "berkehoute traeje",
  "block.minecraft.jungle_stairs": "oerwoudhoute traeje",
  "block.minecraft.crimson_stairs": "helroede houte traeje",
  "block.minecraft.warped_stairs": "spoekachtige houte traeje",
  "block.minecraft.command_block": "opdrachblok",
  "block.minecraft.beacon": "bake",
  "block.minecraft.cobblestone_wall": "keijmoor",
  "block.minecraft.mossy_cobblestone_wall": "mossige keijmoor",
  "block.minecraft.brick_wall": "baksteinen moor",
  "block.minecraft.prismarine_wall": "prismarienmoer",
  "block.minecraft.red_sandstone_wall": "roede zandsjteinen moer",
  "block.minecraft.mossy_stone_brick_wall": "mossige bloksteinen moor",
  "block.minecraft.granite_wall": "granietmoer",
  "block.minecraft.stone_brick_wall": "bloksteinen moor",
  "block.minecraft.nether_brick_wall": "netherbakstein moor",
  "block.minecraft.andesite_wall": "andesietmoer",
  "block.minecraft.red_nether_brick_wall": "roede netherbakstein moor",
  "block.minecraft.sandstone_wall": "zandsjteinen moer",
  "block.minecraft.end_stone_brick_wall": "endbakkstein moor",
  "block.minecraft.diorite_wall": "diorietmoer",
  "block.minecraft.blackstone_wall": "zwartstein moor",
  "block.minecraft.polished_blackstone_wall": "gepolieste zwartstein moor",
  "block.minecraft.polished_blackstone_brick_wall": "gepolieste zwartstein bakstein moor",
  "block.minecraft.stone_button": "steine knop",
  "block.minecraft.oak_button": "eike knop",
  "block.minecraft.spruce_button": "sjparre knop",
  "block.minecraft.birch_button": "berke knop",
  "block.minecraft.jungle_button": "oerwoud knop",
  "block.minecraft.acacia_button": "acacia knop",
  "block.minecraft.dark_oak_button": "donkere eikehoute knop",
  "block.minecraft.crimson_button": "helroede houten knöp",
  "block.minecraft.warped_button": "spoekachtige houten knöp",
  "block.minecraft.polished_blackstone_button": "gepolieste zwartstein knöp",
  "block.minecraft.anvil": "aambild",
  "block.minecraft.chipped_anvil": "gebarsjte aambild",
  "block.minecraft.damaged_anvil": "beschadigd aambild",
  "block.minecraft.trapped_chest": "kis mit val",
  "block.minecraft.light_weighted_pressure_plate": "lichte drukgeveulige plaat",
  "block.minecraft.heavy_weighted_pressure_plate": "zware drukgevoelige plaat",
  "block.minecraft.daylight_detector": "daagleechsensor",
  "block.minecraft.redstone_block": "redstoneblok",
  "block.minecraft.nether_quartz_ore": "netherkwartserts",
  "block.minecraft.hopper": "trechter",
  "block.minecraft.chiseled_quartz_block": "gebieteld kwartsblok",
  "block.minecraft.quartz_block": "kwartsblok",
  "block.minecraft.quartz_bricks": "kwartsbakstein",
  "block.minecraft.quartz_pillar": "kwarts pillaar",
  "block.minecraft.quartz_stairs": "kwarts traeje",
  "block.minecraft.activator_rail": "activatiespoear",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "wit terracotta",
  "block.minecraft.orange_terracotta": "oranje terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "leechtblauwe terracotta",
  "block.minecraft.yellow_terracotta": "gaele terracotta",
  "block.minecraft.lime_terracotta": "limoengreune terracotta",
  "block.minecraft.pink_terracotta": "roze terracotta",
  "block.minecraft.gray_terracotta": "griese terracotta",
  "block.minecraft.light_gray_terracotta": "leechtgrieze terracotta",
  "block.minecraft.cyan_terracotta": "turqouoise terracotta",
  "block.minecraft.purple_terracotta": "paorse terracotta",
  "block.minecraft.blue_terracotta": "blauwe terracotta",
  "block.minecraft.brown_terracotta": "broene terracotta",
  "block.minecraft.green_terracotta": "greune terracotta",
  "block.minecraft.red_terracotta": "roeke terracotta",
  "block.minecraft.black_terracotta": "zjwarte terracotta",
  "block.minecraft.barrier": "barrière",
  "block.minecraft.iron_trapdoor": "iezer valloek",
  "block.minecraft.hay_block": "huijbaal",
  "block.minecraft.white_carpet": "wit kerpèt",
  "block.minecraft.orange_carpet": "oranje kerpèt",
  "block.minecraft.magenta_carpet": "magenta kerpèt",
  "block.minecraft.light_blue_carpet": "leechblauw tapiet",
  "block.minecraft.yellow_carpet": "gael kerpèt",
  "block.minecraft.lime_carpet": "limoengreun tapiet",
  "block.minecraft.pink_carpet": "roze kerpèt",
  "block.minecraft.gray_carpet": "gries kerpèt",
  "block.minecraft.light_gray_carpet": "leechgries tapiet",
  "block.minecraft.cyan_carpet": "turquoise kerpèt",
  "block.minecraft.purple_carpet": "paars kerpèt",
  "block.minecraft.blue_carpet": "blauw kerpèt",
  "block.minecraft.brown_carpet": "broen kerpèt",
  "block.minecraft.green_carpet": "greun kerpèt",
  "block.minecraft.red_carpet": "roed kerpèt",
  "block.minecraft.black_carpet": "zjwart kerpèt",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "kaoleblok",
  "block.minecraft.packed_ice": "pakies",
  "block.minecraft.acacia_stairs": "acaciahoute traeje",
  "block.minecraft.dark_oak_stairs": "donkereikenhoute traeje",
  "block.minecraft.slime_block": "sliémblok",
  "block.minecraft.grass_path": "graaspaej",
  "block.minecraft.sunflower": "zónnebloom",
  "block.minecraft.lilac": "sering",
  "block.minecraft.rose_bush": "roeaze stroek",
  "block.minecraft.peony": "pioenroeas",
  "block.minecraft.tall_grass": "hoog graas",
  "block.minecraft.large_fern": "groete varen",
  "block.minecraft.white_stained_glass": "wit gekleurd glaas",
  "block.minecraft.orange_stained_glass": "oranje gekleurd glaas",
  "block.minecraft.magenta_stained_glass": "magenta gekleurd glaas",
  "block.minecraft.light_blue_stained_glass": "leechtblauwgekleurd glaas",
  "block.minecraft.yellow_stained_glass": "gael gekleurd glaas",
  "block.minecraft.lime_stained_glass": "limoengreungekleurd glaas",
  "block.minecraft.pink_stained_glass": "roze gekleurd glaas",
  "block.minecraft.gray_stained_glass": "gries gekleurd glaas",
  "block.minecraft.light_gray_stained_glass": "leechtgriesgekleurd glaas",
  "block.minecraft.cyan_stained_glass": "turquoise gekleurde glaas",
  "block.minecraft.purple_stained_glass": "paars gekleurd glaas",
  "block.minecraft.blue_stained_glass": "blauw gekleurd glaas",
  "block.minecraft.brown_stained_glass": "broen gekleurd glaas",
  "block.minecraft.green_stained_glass": "greun gekleurd glaas",
  "block.minecraft.red_stained_glass": "roed gekleurde glaas",
  "block.minecraft.black_stained_glass": "zjwart gekleurd glaas",
  "block.minecraft.white_stained_glass_pane": "witgekleurde glazen roet",
  "block.minecraft.orange_stained_glass_pane": "oranjegekleurde glazen roet",
  "block.minecraft.magenta_stained_glass_pane": "magenta gekleurde glazen roet",
  "block.minecraft.light_blue_stained_glass_pane": "leechtblauwgekleurde glazen roet",
  "block.minecraft.yellow_stained_glass_pane": "gael gekleurde glazen roet",
  "block.minecraft.lime_stained_glass_pane": "limoengreungekleurde glazen roet",
  "block.minecraft.pink_stained_glass_pane": "roze gekleurde glazen roet",
  "block.minecraft.gray_stained_glass_pane": "gries gekleurde glazen roet",
  "block.minecraft.light_gray_stained_glass_pane": "leechtgriesgekleurde glazen roet",
  "block.minecraft.cyan_stained_glass_pane": "turquoise gekleurde glazen roet",
  "block.minecraft.purple_stained_glass_pane": "paars gekleurde glazen roet",
  "block.minecraft.blue_stained_glass_pane": "blauw gekleurde glazen roet",
  "block.minecraft.brown_stained_glass_pane": "broen gekleurde glazen roet",
  "block.minecraft.green_stained_glass_pane": "greun gekleurde glazen roet",
  "block.minecraft.red_stained_glass_pane": "roed gekleurde glazen roet",
  "block.minecraft.black_stained_glass_pane": "zjwart gekleurde glazen roet",
  "block.minecraft.prismarine": "prismarien",
  "block.minecraft.prismarine_bricks": "prismarienbakstein",
  "block.minecraft.dark_prismarine": "dónkere prismarine",
  "block.minecraft.prismarine_stairs": "prismarien traeje",
  "block.minecraft.prismarine_brick_stairs": "prismarienbakstein traeje",
  "block.minecraft.dark_prismarine_stairs": "donkerprismarien traeje",
  "block.minecraft.sea_lantern": "ziëlantaarn",
  "block.minecraft.red_sandstone": "roeje zandstein",
  "block.minecraft.chiseled_red_sandstone": "gebietelde roeje zandstein",
  "block.minecraft.cut_red_sandstone": "gesneeje roeie zandstein",
  "block.minecraft.red_sandstone_stairs": "roeje zandstein traeje",
  "block.minecraft.repeating_command_block": "herhaolend opdrachblock",
  "block.minecraft.chain_command_block": "gekoppeld opdrachblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "netherkroedblok",
  "block.minecraft.warped_wart_block": "spoekachtig kruudblok",
  "block.minecraft.red_nether_bricks": "roede netherbakstein",
  "block.minecraft.bone_block": "bottenblok",
  "block.minecraft.structure_void": "structuurleagte",
  "block.minecraft.observer": "observeerder",
  "block.minecraft.shulker_box": "shulkerdoeas",
  "block.minecraft.white_shulker_box": "witte shulkerdoeas",
  "block.minecraft.orange_shulker_box": "oranje shulkerdoeas",
  "block.minecraft.magenta_shulker_box": "magenta shulkerdoeas",
  "block.minecraft.light_blue_shulker_box": "leechblauwe shulkerdoeas",
  "block.minecraft.yellow_shulker_box": "gaele shulkerdoeas",
  "block.minecraft.lime_shulker_box": "limoengreune shulkerdoes",
  "block.minecraft.pink_shulker_box": "roze shulkerdoeas",
  "block.minecraft.gray_shulker_box": "grieze shulkerdoeas",
  "block.minecraft.light_gray_shulker_box": "leechtgrieze shulkerdoeas",
  "block.minecraft.cyan_shulker_box": "turquoise shulkerdoeas",
  "block.minecraft.purple_shulker_box": "paarse shulkerdoeas",
  "block.minecraft.blue_shulker_box": "blauwe shulkerdoeas",
  "block.minecraft.brown_shulker_box": "broene shulkerdoeas",
  "block.minecraft.green_shulker_box": "greune shulkerdoeas",
  "block.minecraft.red_shulker_box": "roeje shulkerdoeas",
  "block.minecraft.black_shulker_box": "zjwarte shulkerdoeas",
  "block.minecraft.white_glazed_terracotta": "witgeglazuurde terracotta",
  "block.minecraft.orange_glazed_terracotta": "oranjegeglazuurde terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magentageglazuurde terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "leechtblauwgeglazuurde terracotta",
  "block.minecraft.yellow_glazed_terracotta": "gaelgeglazuurde terracotta",
  "block.minecraft.lime_glazed_terracotta": "limoengreungeglazuurde terracotta",
  "block.minecraft.pink_glazed_terracotta": "rozegeglazuurde terracotta",
  "block.minecraft.gray_glazed_terracotta": "griesgeglazuurde terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "leechtgriesgeglazuurde terracotta",
  "block.minecraft.cyan_glazed_terracotta": "turquoisegeglazuurde terracotta",
  "block.minecraft.purple_glazed_terracotta": "paarsgeglazuurde terracotta",
  "block.minecraft.blue_glazed_terracotta": "blauwgeglazuurde terracotta",
  "block.minecraft.brown_glazed_terracotta": "broengeglazuurde terracotta",
  "block.minecraft.green_glazed_terracotta": "greungeglazuurde terracotta",
  "block.minecraft.red_glazed_terracotta": "roeadgeglazuurde terracotta",
  "block.minecraft.black_glazed_terracotta": "zjwartgeglazuurde terracotta",
  "block.minecraft.white_concrete": "wit beton",
  "block.minecraft.orange_concrete": "oranje beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "leechtblauw beton",
  "block.minecraft.yellow_concrete": "gael beton",
  "block.minecraft.lime_concrete": "limoengreun beton",
  "block.minecraft.pink_concrete": "roze beton",
  "block.minecraft.gray_concrete": "gries beton",
  "block.minecraft.light_gray_concrete": "leechtgries beton",
  "block.minecraft.cyan_concrete": "turquoise beton",
  "block.minecraft.purple_concrete": "paars beton",
  "block.minecraft.blue_concrete": "blauw beton",
  "block.minecraft.brown_concrete": "broen beton",
  "block.minecraft.green_concrete": "greun beton",
  "block.minecraft.red_concrete": "roead beton",
  "block.minecraft.black_concrete": "zjwart beton",
  "block.minecraft.white_concrete_powder": "wit cement",
  "block.minecraft.orange_concrete_powder": "oranje cement",
  "block.minecraft.magenta_concrete_powder": "magenta cement",
  "block.minecraft.light_blue_concrete_powder": "leechtblauw cement",
  "block.minecraft.yellow_concrete_powder": "gael cement",
  "block.minecraft.lime_concrete_powder": "limoengreun cement",
  "block.minecraft.pink_concrete_powder": "roze cement",
  "block.minecraft.gray_concrete_powder": "gries cement",
  "block.minecraft.light_gray_concrete_powder": "leechtgries cement",
  "block.minecraft.cyan_concrete_powder": "turquoise cement",
  "block.minecraft.purple_concrete_powder": "paars cement",
  "block.minecraft.blue_concrete_powder": "blauw cement",
  "block.minecraft.brown_concrete_powder": "broen cement",
  "block.minecraft.green_concrete_powder": "greun cement",
  "block.minecraft.red_concrete_powder": "roed cement",
  "block.minecraft.black_concrete_powder": "zjwart cement",
  "block.minecraft.turtle_egg": "sjildkróddel ei",
  "block.minecraft.dead_tube_coral_block": "doed buuskoraalblok",
  "block.minecraft.dead_brain_coral_block": "doed hersenkoraalblok",
  "block.minecraft.dead_bubble_coral_block": "doed blaaskoraalblok",
  "block.minecraft.dead_fire_coral_block": "doed brandkoraalblok",
  "block.minecraft.dead_horn_coral_block": "doed haorekoraalblok",
  "block.minecraft.tube_coral_block": "buuskoraalblok",
  "block.minecraft.brain_coral_block": "hersenkoraalblok",
  "block.minecraft.bubble_coral_block": "blaaskoraalblok",
  "block.minecraft.fire_coral_block": "brandkoraalblok",
  "block.minecraft.horn_coral_block": "haorekoraalblok",
  "block.minecraft.tube_coral": "buuskoraal",
  "block.minecraft.brain_coral": "hersenkoraal",
  "block.minecraft.bubble_coral": "blaaskoraal",
  "block.minecraft.fire_coral": "brandkoraal",
  "block.minecraft.horn_coral": "haorekoraal",
  "block.minecraft.dead_brain_coral": "doed hersenkoraal",
  "block.minecraft.dead_bubble_coral": "doed blaaskoraal",
  "block.minecraft.dead_fire_coral": "doed brandkoraal",
  "block.minecraft.dead_horn_coral": "doed hoornkoraal",
  "block.minecraft.dead_tube_coral": "doed buiskoraal",
  "block.minecraft.tube_coral_fan": "buuskoraalwaaijer",
  "block.minecraft.brain_coral_fan": "hersenkoraalwaaijer",
  "block.minecraft.bubble_coral_fan": "blaaskoraalwaaijer",
  "block.minecraft.fire_coral_fan": "brandkoraalwaaijer",
  "block.minecraft.horn_coral_fan": "haorekoraalwaaijer",
  "block.minecraft.dead_tube_coral_fan": "doeje buiskoraalwaaier",
  "block.minecraft.dead_brain_coral_fan": "doeje hersenkoraalwaaier",
  "block.minecraft.dead_bubble_coral_fan": "doeje blaaskoraalwaaier",
  "block.minecraft.dead_fire_coral_fan": "doeje brandkoraalwaaier",
  "block.minecraft.dead_horn_coral_fan": "doeje hoornkoraalwaaier",
  "block.minecraft.blue_ice": "blauw ies",
  "block.minecraft.conduit": "krach van oet de zee",
  "block.minecraft.polished_granite_stairs": "gepolieste graniet traeje",
  "block.minecraft.smooth_red_sandstone_stairs": "gladde roede zandstein traeje",
  "block.minecraft.mossy_stone_brick_stairs": "mossige blokstein traeje",
  "block.minecraft.polished_diorite_stairs": "gepolieste dioriet traeje",
  "block.minecraft.mossy_cobblestone_stairs": "mossige keistein traeje",
  "block.minecraft.end_stone_brick_stairs": "endblokstein traeje",
  "block.minecraft.stone_stairs": "steine traeje",
  "block.minecraft.smooth_sandstone_stairs": "gladde zandstein traeje",
  "block.minecraft.smooth_quartz_stairs": "gladde kwarts traeje",
  "block.minecraft.granite_stairs": "graniet traeje",
  "block.minecraft.andesite_stairs": "andesiet traeje",
  "block.minecraft.red_nether_brick_stairs": "roede netherbakstein traeje",
  "block.minecraft.polished_andesite_stairs": "gepolieste andesiet traeje",
  "block.minecraft.diorite_stairs": "dioriet traeje",
  "block.minecraft.polished_granite_slab": "gepolieste granietplaat",
  "block.minecraft.smooth_red_sandstone_slab": "gladde roede zandsjteinen plaat",
  "block.minecraft.mossy_stone_brick_slab": "mossige bloksteinen plaat",
  "block.minecraft.polished_diorite_slab": "gepolieste diorietplaat",
  "block.minecraft.mossy_cobblestone_slab": "mossige keisjteinen plaat",
  "block.minecraft.end_stone_brick_slab": "endbloksteinen plaat",
  "block.minecraft.smooth_sandstone_slab": "gladde zandsjteinen plaat",
  "block.minecraft.smooth_quartz_slab": "gladde kwartsplaat",
  "block.minecraft.granite_slab": "granietplaat",
  "block.minecraft.andesite_slab": "andesietplaat",
  "block.minecraft.red_nether_brick_slab": "roede netherbaksteinen plaat",
  "block.minecraft.polished_andesite_slab": "gepolieste andesietplaat",
  "block.minecraft.diorite_slab": "diorietplaat",
  "block.minecraft.scaffolding": "sjtèlling",
  "block.minecraft.iron_door": "iezere deur",
  "block.minecraft.oak_door": "eike duuer",
  "block.minecraft.spruce_door": "sparrenhoute duuer",
  "block.minecraft.birch_door": "birkehoute duuer",
  "block.minecraft.jungle_door": "oerwoudhouten duuer",
  "block.minecraft.acacia_door": "acaciahouten duuer",
  "block.minecraft.dark_oak_door": "dónkere eikenhouten duuer",
  "block.minecraft.crimson_door": "helroede deur",
  "block.minecraft.warped_door": "spoekachtige deur",
  "block.minecraft.repeater": "redstoneversterker",
  "block.minecraft.comparator": "redstonevergelieker",
  "block.minecraft.structure_block": "structuurblok",
  "block.minecraft.jigsaw": "puzzelblok",
  "item.minecraft.turtle_helmet": "sjildkróddelsjild□□wannier op de kop:□+2 harnas",
  "item.minecraft.scute": "sjild",
  "item.minecraft.iron_shovel": "iezer sjöp□□wannier in schriefhand:□+3.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.iron_pickaxe": "iezer bikkel□□wannier in schriefhand:□+3 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.iron_axe": "iezer biel□□wannier in schriefhand:□+8 aanvalssjaaj□-3.1 aanval sjnelhied",
  "item.minecraft.flint_and_steel": "vuursjtein en sjtaol",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "bäög",
  "item.minecraft.arrow": "piel",
  "item.minecraft.coal": "sjteinkaol",
  "item.minecraft.charcoal": "houtskaol",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "iezerstaaf",
  "item.minecraft.gold_ingot": "goudstaaf",
  "item.minecraft.netherite_ingot": "netherietstaaf",
  "item.minecraft.netherite_scrap": "netherietschroet",
  "item.minecraft.iron_sword": "iezer zjwaard□□wannier in schriefhand:□+5 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.wooden_sword": "houte zjwaard□□wannier in schriefhand:□+3 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.wooden_shovel": "houte sjöp□□wannier in schriefhand:□+1.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.wooden_pickaxe": "houte bikkel□□wannier in schriefhand:□+1 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.wooden_axe": "hout biel□□wannier in schriefhand:□+6 aanvalssjaaj□-3.2 aanval sjnelhied",
  "item.minecraft.stone_sword": "sjteine zjwaard□□wannier in schriefhand:□+4 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.stone_shovel": "sjteine sjöp□□wannier in schriefhand:□+2.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.stone_pickaxe": "sjtein bikkel□□wannier in schriefhand:□+2 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.stone_axe": "sjtein biel□□wannier in schriefhand:□+8 aanvalssjaaj□-3.2 aanval sjnelhied",
  "item.minecraft.diamond_sword": "diamante zjwaard□□wannier in schriefhand:□+6 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.diamond_shovel": "diamante sjöp□□wannier in schriefhand:□+4.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.diamond_pickaxe": "diamante bikkel□□wannier in schriefhand:□+4 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.diamond_axe": "diamant biel□□wannier in schriefhand:□+8 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.stick": "sjtek",
  "item.minecraft.bowl": "kom",
  "item.minecraft.mushroom_stew": "paddestoel sop",
  "item.minecraft.golden_sword": "goude zjwaard□□wannier in schriefhand:□+3 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.golden_shovel": "goude sjöp□□wannier in schriefhand:□+1.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.golden_pickaxe": "goude bikkel□□wannier in schriefhand:□+1 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.golden_axe": "goude biel□□wannier in schriefhand:□+6 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.netherite_sword": "netherieten zwaard□□wannier in schriefhand:□+7 aanvalssjaaj□-2.4 aanval sjnelhied",
  "item.minecraft.netherite_shovel": "netherieten schup□□wannier in schriefhand:□+5.5 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.netherite_pickaxe": "netherieten houwiel□□wannier in schriefhand:□+5 aanvalssjaaj□-2.8 aanval sjnelhied",
  "item.minecraft.netherite_axe": "netherieten biel□□wannier in schriefhand:□+9 aanvalssjaaj□-3 aanval sjnelhied",
  "item.minecraft.string": "dräöj",
  "item.minecraft.feather": "vaer",
  "item.minecraft.gunpowder": "buskroet",
  "item.minecraft.wooden_hoe": "houte sjoffel□□wannier in schriefhand:□-3 aanval sjnelhied",
  "item.minecraft.stone_hoe": "sjteine sjoffel□□wannier in schriefhand:□-2 aanval sjnelhied",
  "item.minecraft.iron_hoe": "iezere sjoffel□□wannier in schriefhand:□-1 aanval sjnelhied",
  "item.minecraft.diamond_hoe": "diamante sjoffel□□wannier in schriefhand:",
  "item.minecraft.golden_hoe": "gouden sjoffel□□wannier in schriefhand:□-3 aanval sjnelhied",
  "item.minecraft.netherite_hoe": "netherieten schuffel□□wannier in schriefhand:",
  "item.minecraft.wheat_seeds": "tarwezaden",
  "item.minecraft.wheat": "weit",
  "item.minecraft.bread": "broed",
  "item.minecraft.leather_helmet": "laere kap□□wannier op de kop:□+1 harnas",
  "item.minecraft.leather_chestplate": "laere tuniek□□wannier op 't lichaam:□+3 harnas",
  "item.minecraft.leather_leggings": "laere bóks□□wannier op de bein:□+2 harnas",
  "item.minecraft.leather_boots": "laere laarzen□□wannier te veut:□+1 harnas",
  "item.minecraft.chainmail_helmet": "maliënkap□□wannier op de kop:□+2 harnas",
  "item.minecraft.chainmail_chestplate": "maliënkolder□□wannier op 't lichaam:□+5 harnas",
  "item.minecraft.chainmail_leggings": "maliënbóks□□wannier op de bein:□+4 harnas",
  "item.minecraft.chainmail_boots": "maliënlaarzen□□wannier te veut:□+1 harnas",
  "item.minecraft.iron_helmet": "iezere helm□□wannier op de kop:□+2 harnas",
  "item.minecraft.iron_chestplate": "iezere borsplaat□□wannier op 't lichaam:□+6 harnas",
  "item.minecraft.iron_leggings": "iezere beinstukke□□wannier op de bein:□+5 harnas",
  "item.minecraft.iron_boots": "iezere laarzen□□wannier te veut:□+2 harnas",
  "item.minecraft.diamond_helmet": "diamante helm□□wannier op de kop:□+3 harnas□+2 harnashelligheid",
  "item.minecraft.diamond_chestplate": "diamante borstplaat□□wannier op 't lichaam:□+8 harnas□+2 harnashelligheid",
  "item.minecraft.diamond_leggings": "diamante beinstukken□□wannier op de bein:□+6 harnas□+2 harnashelligheid",
  "item.minecraft.diamond_boots": "diamante laarzen□□wannier te veut:□+3 harnas□+2 harnashelligheid",
  "item.minecraft.golden_helmet": "gouden helm□□wannier op de kop:□+2 harnas",
  "item.minecraft.golden_chestplate": "gouden borstplaat□□wannier op 't lichaam:□+5 harnas",
  "item.minecraft.golden_leggings": "gouden beinstukken□□wannier op de bein:□+3 harnas",
  "item.minecraft.golden_boots": "gouden laarzen□□wannier te veut:□+1 harnas",
  "item.minecraft.netherite_helmet": "netherieten helm□□wannier op de kop:□+3 harnas□+3 harnashelligheid□+1 trökslaagweerstand",
  "item.minecraft.netherite_chestplate": "netherieten borstplaat□□wannier op 't lichaam:□+8 harnas□+3 harnashelligheid□+1 trökslaagweerstand",
  "item.minecraft.netherite_leggings": "netherieten boks□□wannier op de bein:□+6 harnas□+3 harnashelligheid□+1 trökslaagweerstand",
  "item.minecraft.netherite_boots": "netherieten laars□□wannier te veut:□+3 harnas□+3 harnashelligheid□+1 trökslaagweerstand",
  "item.minecraft.flint": "vuursjtein",
  "item.minecraft.porkchop": "rauw verkesvleisj",
  "item.minecraft.cooked_porkchop": "gekaok verkesvleisj",
  "item.minecraft.painting": "sjilderie",
  "item.minecraft.golden_apple": "gouwe appel",
  "item.minecraft.enchanted_golden_apple": "betoverde gouwe appel",
  "block.minecraft.oak_sign": "eikenhouten bord",
  "block.minecraft.spruce_sign": "sjparrenhouten bord",
  "block.minecraft.birch_sign": "berkenhouten bord",
  "block.minecraft.jungle_sign": "oerwoudhouten bord",
  "block.minecraft.acacia_sign": "acaciahouten bord",
  "block.minecraft.dark_oak_sign": "donkereikenhouten bord",
  "block.minecraft.crimson_sign": "helroed houten bord",
  "block.minecraft.warped_sign": "spoekachtige houten bord",
  "item.minecraft.bucket": "tob",
  "item.minecraft.water_bucket": "tob water",
  "item.minecraft.lava_bucket": "tob lava",
  "item.minecraft.minecart": "mienkar",
  "item.minecraft.saddle": "zaal",
  "item.minecraft.redstone": "redstonestùf",
  "item.minecraft.snowball": "sjniebal",
  "item.minecraft.oak_boat": "eikehouten boeat",
  "item.minecraft.leather": "leer",
  "item.minecraft.milk_bucket": "tob melk",
  "item.minecraft.pufferfish_bucket": "tob mit keugelvès",
  "item.minecraft.salmon_bucket": "tob mit zalm",
  "item.minecraft.cod_bucket": "tob mit kabeljauw",
  "item.minecraft.tropical_fish_bucket": "tob mit tropische vésj",
  "item.minecraft.brick": "bakstein",
  "item.minecraft.clay_ball": "kliébal",
  "block.minecraft.dried_kelp_block": "gedraögde kelp blok",
  "item.minecraft.paper": "pepeer",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "sliémbal",
  "item.minecraft.chest_minecart": "mienkar mit kis",
  "item.minecraft.furnace_minecart": "mienkar mit aove",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kómpas",
  "item.minecraft.fishing_rod": "vèsgaert",
  "item.minecraft.clock": "klok",
  "item.minecraft.glowstone_dust": "gloeisteinstùf",
  "item.minecraft.cod": "rauwe kabeljauw",
  "item.minecraft.salmon": "rauwe zalm",
  "item.minecraft.tropical_fish": "tropische vésj",
  "item.minecraft.pufferfish": "keugelvès",
  "item.minecraft.cooked_cod": "gekoakte kabeljauw",
  "item.minecraft.cooked_salmon": "gekoakte zalm",
  "item.minecraft.ink_sac": "inkttes",
  "item.minecraft.red_dye": "roede kleursjtóf",
  "item.minecraft.green_dye": "greune kleursjtóf",
  "item.minecraft.cocoa_beans": "cacaobonen",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "paarse kleurstof",
  "item.minecraft.cyan_dye": "turquoise kleurstof",
  "item.minecraft.light_gray_dye": "leechtgrieze kleurstof",
  "item.minecraft.gray_dye": "gries kleurstof",
  "item.minecraft.pink_dye": "roze kleurstof",
  "item.minecraft.lime_dye": "limoengreun kleurstof",
  "item.minecraft.yellow_dye": "gaele kleursjtóf",
  "item.minecraft.light_blue_dye": "leechtblauwe kleurstof",
  "item.minecraft.magenta_dye": "magenta kleurstof",
  "item.minecraft.orange_dye": "oranje kleurstof",
  "item.minecraft.bone_meal": "beendermeel",
  "item.minecraft.blue_dye": "blauwe kleursjtóf",
  "item.minecraft.brown_dye": "broene kleursjtóf",
  "item.minecraft.black_dye": "zwarte kleursjtóf",
  "item.minecraft.white_dye": "witter kleursjtóf",
  "item.minecraft.bone": "knaok",
  "item.minecraft.sugar": "soeker",
  "block.minecraft.cake": "vlaai",
  "block.minecraft.white_bed": "wit bèd",
  "block.minecraft.orange_bed": "oranje bèd",
  "block.minecraft.magenta_bed": "magenta bèd",
  "block.minecraft.light_blue_bed": "leechtblauw bèd",
  "block.minecraft.yellow_bed": "gael bèd",
  "block.minecraft.lime_bed": "limoengreun bèd",
  "block.minecraft.pink_bed": "roze bèd",
  "block.minecraft.gray_bed": "gries bèd",
  "block.minecraft.light_gray_bed": "leechtgries bèd",
  "block.minecraft.cyan_bed": "turquoise bèd",
  "block.minecraft.purple_bed": "paars bèd",
  "block.minecraft.blue_bed": "blauw bèd",
  "block.minecraft.brown_bed": "broen bèd",
  "block.minecraft.green_bed": "greun bèd",
  "block.minecraft.red_bed": "roed bèd",
  "block.minecraft.black_bed": "zjwart bèd",
  "item.minecraft.cookie": "koekje",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "sjier",
  "item.minecraft.melon_slice": "meloenschijf",
  "item.minecraft.dried_kelp": "gedrüugde kelp",
  "item.minecraft.pumpkin_seeds": "pompoenpitten",
  "item.minecraft.melon_seeds": "meloenzoaden",
  "item.minecraft.beef": "rauw bufsjtök",
  "item.minecraft.cooked_beef": "bufsjtök",
  "item.minecraft.chicken": "rauw hin",
  "item.minecraft.cooked_chicken": "gekaokde kiep",
  "item.minecraft.rotten_flesh": "gerot vleisj",
  "item.minecraft.ender_pearl": "enderpaerel",
  "item.minecraft.blaze_rod": "blaze sjtaaf",
  "item.minecraft.ghast_tear": "ghast traon",
  "item.minecraft.gold_nugget": "goudklompje",
  "item.minecraft.nether_wart": "netherkroed",
  "item.minecraft.potion": "onmaakbare drank□gein effecten",
  "item.minecraft.glass_bottle": "glaas fles",
  "item.minecraft.spider_eye": "spinnenoug",
  "item.minecraft.fermented_spider_eye": "gefermenteerd spinnenoug",
  "item.minecraft.blaze_powder": "blaze poejer",
  "item.minecraft.magma_cream": "magmacrème",
  "block.minecraft.brewing_stand": "brouwsjtandaard",
  "block.minecraft.cauldron": "kaetel",
  "item.minecraft.ender_eye": "enderoug",
  "item.minecraft.glistering_melon_slice": "glinsterende meloensjief",
  "item.minecraft.bat_spawn_egg": "flaermoesspawnei",
  "item.minecraft.bee_spawn_egg": "biejspawnei",
  "item.minecraft.blaze_spawn_egg": "blazespawnei",
  "item.minecraft.cat_spawn_egg": "kattenspawnei",
  "item.minecraft.cave_spider_spawn_egg": "grottenspinnenspawnei",
  "item.minecraft.chicken_spawn_egg": "kippespawnei",
  "item.minecraft.cod_spawn_egg": "kabeljauwspawnei",
  "item.minecraft.cow_spawn_egg": "kospawnei",
  "item.minecraft.creeper_spawn_egg": "creeperspawnei",
  "item.minecraft.dolphin_spawn_egg": "dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "aezelspawnei",
  "item.minecraft.drowned_spawn_egg": "drenkelingenspawnei",
  "item.minecraft.elder_guardian_spawn_egg": "oudebewakerspawnei",
  "item.minecraft.enderman_spawn_egg": "endermannenspawnei",
  "item.minecraft.endermite_spawn_egg": "endermitespawnei",
  "item.minecraft.evoker_spawn_egg": "oproeperspawnei",
  "item.minecraft.fox_spawn_egg": "vossespawnei",
  "item.minecraft.ghast_spawn_egg": "ghastspawnei",
  "item.minecraft.guardian_spawn_egg": "bewakerspawnei",
  "item.minecraft.hoglin_spawn_egg": "hoglinspawnei",
  "item.minecraft.horse_spawn_egg": "paerdespawnei",
  "item.minecraft.husk_spawn_egg": "mummiespawnei",
  "item.minecraft.llama_spawn_egg": "lamaspawnei",
  "item.minecraft.magma_cube_spawn_egg": "magmakubesspawnei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomspawnei",
  "item.minecraft.mule_spawn_egg": "muilaezelspawnei",
  "item.minecraft.ocelot_spawn_egg": "ocelottenspawnei",
  "item.minecraft.panda_spawn_egg": "pandaspawnei",
  "item.minecraft.parrot_spawn_egg": "pappegaejespawnei",
  "item.minecraft.phantom_spawn_egg": "fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "verkespawnei",
  "item.minecraft.piglin_spawn_egg": "piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "roverspawnei",
  "item.minecraft.polar_bear_spawn_egg": "iesbaerespawnei",
  "item.minecraft.pufferfish_spawn_egg": "keugelvèsespawnei",
  "item.minecraft.rabbit_spawn_egg": "kenienespawnei",
  "item.minecraft.ravager_spawn_egg": "verwoesterspawnei",
  "item.minecraft.salmon_spawn_egg": "zalmspawnei",
  "item.minecraft.sheep_spawn_egg": "sjaopespawnei",
  "item.minecraft.shulker_spawn_egg": "shulkerspawnei",
  "item.minecraft.silverfish_spawn_egg": "zilvervèsjespawnei",
  "item.minecraft.skeleton_spawn_egg": "skelettenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "skeletpaerdespawnei",
  "item.minecraft.slime_spawn_egg": "sliémkubesspawnei",
  "item.minecraft.spider_spawn_egg": "spinnenspawnei",
  "item.minecraft.squid_spawn_egg": "inktvèsjespawnei",
  "item.minecraft.stray_spawn_egg": "verdwaaldenspawnei",
  "item.minecraft.strider_spawn_egg": "lavariederspawnei",
  "item.minecraft.trader_llama_spawn_egg": "hanjelaerslamaspawnei",
  "item.minecraft.tropical_fish_spawn_egg": "tropischevèsjespawnei",
  "item.minecraft.turtle_spawn_egg": "sjildkróddelespawnei",
  "item.minecraft.vex_spawn_egg": "ergernissenspawnei",
  "item.minecraft.villager_spawn_egg": "durpelingenspawnei",
  "item.minecraft.vindicator_spawn_egg": "verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "róndjreizendehanjelaerrsspawnei",
  "item.minecraft.witch_spawn_egg": "heksenspawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelettenspawnei",
  "item.minecraft.wolf_spawn_egg": "wolvenspawnei",
  "item.minecraft.zoglin_spawn_egg": "zoglinspawnei",
  "item.minecraft.zombie_spawn_egg": "zombiespawnei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepaerdespawnei",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorpelingenspawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombiepiglinspawnei",
  "item.minecraft.experience_bottle": "flesj der betouvering",
  "item.minecraft.fire_charge": "vuurbal",
  "item.minecraft.writable_book": "book 'n vaer",
  "item.minecraft.written_book": "geschreven book",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "voorwerpliest",
  "block.minecraft.flower_pot": "bloompot",
  "item.minecraft.carrot": "wórtel",
  "item.minecraft.potato": "aerpel",
  "item.minecraft.baked_potato": "gebakke aerpel",
  "item.minecraft.poisonous_potato": "vergiftige aerpel",
  "item.minecraft.map": "laege kaart",
  "item.minecraft.golden_carrot": "gouwe wortel",
  "block.minecraft.skeleton_skull": "skelettenschedel",
  "block.minecraft.wither_skeleton_skull": "witherskelettenschedel",
  "block.minecraft.player_head": "sjpeler kop",
  "block.minecraft.zombie_head": "zombiehoofd",
  "block.minecraft.creeper_head": "creeperhoofd",
  "block.minecraft.dragon_head": "drakenhoofd",
  "item.minecraft.carrot_on_a_stick": "wortel op een stek",
  "item.minecraft.warped_fungus_on_a_stick": "spoekachtige zwam aan ein stukske",
  "item.minecraft.nether_star": "nether sjtar",
  "item.minecraft.pumpkin_pie": "pompoentoert",
  "item.minecraft.firework_rocket": "vuurpiel",
  "item.minecraft.firework_star": "vuurwerksjter",
  "item.minecraft.enchanted_book": "betouverd book",
  "item.minecraft.nether_brick": "netherbakstein",
  "item.minecraft.quartz": "netherkwarts",
  "item.minecraft.tnt_minecart": "mienkar mit tnt",
  "item.minecraft.hopper_minecart": "mienkar mit trechter",
  "item.minecraft.prismarine_shard": "prismariensjerf",
  "item.minecraft.prismarine_crystals": "prismarienkristallen",
  "item.minecraft.rabbit": "rauw kenienevleisj",
  "item.minecraft.cooked_rabbit": "gebraoje kenienvleisj",
  "item.minecraft.rabbit_stew": "kenienestoofpot",
  "item.minecraft.rabbit_foot": "kenienepuuetje",
  "item.minecraft.rabbit_hide": "kenienehoed",
  "item.minecraft.armor_stand": "harnashouder",
  "item.minecraft.iron_horse_armor": "iezere paerdeharnas",
  "item.minecraft.golden_horse_armor": "gouwe paerdeharnas",
  "item.minecraft.diamond_horse_armor": "diamante paerdeharnas",
  "item.minecraft.leather_horse_armor": "lieëre paerden sjild",
  "item.minecraft.lead": "leidtouw",
  "item.minecraft.name_tag": "naamkaartje",
  "item.minecraft.command_block_minecart": "mienkar mit opdrachblok",
  "item.minecraft.mutton": "rauw sjaopevleisj",
  "item.minecraft.cooked_mutton": "gebraoje sjaopevleis",
  "block.minecraft.white_banner": "witte banier",
  "block.minecraft.orange_banner": "oranje banier",
  "block.minecraft.magenta_banner": "magenta banier",
  "block.minecraft.light_blue_banner": "leechtblauwe banier",
  "block.minecraft.yellow_banner": "gaele banier",
  "block.minecraft.lime_banner": "limoengreune banier",
  "block.minecraft.pink_banner": "roze banier",
  "block.minecraft.gray_banner": "grieze banier",
  "block.minecraft.light_gray_banner": "leechtgrieze banier",
  "block.minecraft.cyan_banner": "turquoise banier",
  "block.minecraft.purple_banner": "paarse banier",
  "block.minecraft.blue_banner": "blauwe banier",
  "block.minecraft.brown_banner": "broene banier",
  "block.minecraft.green_banner": "greune banier",
  "block.minecraft.red_banner": "roede banier",
  "block.minecraft.black_banner": "zjwarte banier",
  "item.minecraft.end_crystal": "endkristal",
  "item.minecraft.chorus_fruit": "chorusfruit",
  "item.minecraft.popped_chorus_fruit": "gepoft chorusfruit",
  "item.minecraft.beetroot": "biet",
  "item.minecraft.beetroot_seeds": "bietenzoaden",
  "item.minecraft.beetroot_soup": "bietensoep",
  "item.minecraft.dragon_breath": "drakenaom",
  "item.minecraft.splash_potion": "spattend onmaakbaar drenkske□gein effecten",
  "item.minecraft.spectral_arrow": "spectrale piel",
  "item.minecraft.tipped_arrow": "onmaakbare getipte piel□gein effecten",
  "item.minecraft.lingering_potion": "aanhoudend onmaakbaar drenkske□gein effecten",
  "item.minecraft.shield": "sjild",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "sparrehouten boeat",
  "item.minecraft.birch_boat": "birkehouten boeat",
  "item.minecraft.jungle_boat": "oerwoudhouten boeat",
  "item.minecraft.acacia_boat": "acaciahouten boeat",
  "item.minecraft.dark_oak_boat": "donkereikenhouten boeat",
  "item.minecraft.totem_of_undying": "totem der onsterfelijkhied",
  "item.minecraft.shulker_shell": "shulkerschelp",
  "item.minecraft.iron_nugget": "iezerklumpke",
  "item.minecraft.knowledge_book": "book der kennis",
  "item.minecraft.debug_stick": "debugsjtek",
  "item.minecraft.music_disc_13": "meziekplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "meziekplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "meziekplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "meziekplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "meziekplaat□c418 - far",
  "item.minecraft.music_disc_mall": "meziekplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "meziekplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "meziekplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "meziekplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "meziekplaat□c418 - ward",
  "item.minecraft.music_disc_11": "meziekplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "meziekplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "meziekplaat□lena raine - pigstep",
  "item.minecraft.trident": "drietand□□wannier in schriefhand:□+8 aanvalssjaaj□-2.9 aanval sjnelhied",
  "item.minecraft.phantom_membrane": "fantoommembraan",
  "item.minecraft.nautilus_shell": "nautilussjölp",
  "item.minecraft.heart_of_the_sea": "hert van de zië",
  "item.minecraft.crossbow": "kruutsbaog",
  "item.minecraft.suspicious_stew": "geheimzinnige stoofpot",
  "block.minecraft.loom": "weefgetouw",
  "item.minecraft.flower_banner_pattern": "banierpatroon□bloomwapen",
  "item.minecraft.creeper_banner_pattern": "banierpatroon□creeperwapen",
  "item.minecraft.skull_banner_pattern": "banierpatroon□schedelwapen",
  "item.minecraft.mojang_banner_pattern": "banierpatroon□mojangwapen",
  "item.minecraft.globe_banner_pattern": "banner patroen□globe",
  "item.minecraft.piglin_banner_pattern": "banierpatroon□snoet",
  "block.minecraft.composter": "kómposbak",
  "block.minecraft.barrel": "vaat",
  "block.minecraft.smoker": "rouker",
  "block.minecraft.blast_furnace": "hoogaove",
  "block.minecraft.cartography_table": "kartografietaofel",
  "block.minecraft.fletching_table": "bevederingstaofel",
  "block.minecraft.grindstone": "sliepsjtein",
  "block.minecraft.lectern": "lessenaar",
  "block.minecraft.smithing_table": "smeedstaofel",
  "block.minecraft.stonecutter": "sjteinsjnieder",
  "block.minecraft.bell": "bel",
  "block.minecraft.lantern": "lantaer",
  "block.minecraft.soul_lantern": "zielenlantaarn",
  "item.minecraft.sweet_berries": "zeutbessen",
  "block.minecraft.campfire": "kampvuur",
  "block.minecraft.soul_campfire": "zielenkampveur",
  "block.minecraft.shroomlight": "zwammenleecht",
  "item.minecraft.honeycomb": "höningraat",
  "block.minecraft.bee_nest": "biejenest",
  "block.minecraft.beehive": "biejekorf",
  "item.minecraft.honey_bottle": "höning fleske",
  "block.minecraft.honey_block": "höning bluk",
  "block.minecraft.honeycomb_block": "höningraat bluk",
  "block.minecraft.lodestone": "zeilstein",
  "block.minecraft.netherite_block": "netherietblok",
  "block.minecraft.ancient_debris": "alt puin",
  "block.minecraft.target": "doelwit",
  "block.minecraft.crying_obsidian": "huilend obsidiaan",
  "block.minecraft.blackstone": "zwartstein",
  "block.minecraft.blackstone_slab": "zwartstein plaat",
  "block.minecraft.blackstone_stairs": "zwartstein traeje",
  "block.minecraft.gilded_blackstone": "vergulde zwartstein",
  "block.minecraft.polished_blackstone": "gepolieste zwartstein",
  "block.minecraft.polished_blackstone_slab": "gepolieste zwartstein plaat",
  "block.minecraft.polished_blackstone_stairs": "gepolieste zwartstein traeje",
  "block.minecraft.chiseled_polished_blackstone": "gebietelde gepolieste zwartstein",
  "block.minecraft.polished_blackstone_bricks": "gepolieste zwartstein bakstein",
  "block.minecraft.polished_blackstone_brick_slab": "gepolieste zwartstein bakstein plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "gepolieste zwartstein bakstein traeje",
  "block.minecraft.cracked_polished_blackstone_bricks": "gebarste gepolieste zwartstein bakstein",
  "block.minecraft.respawn_anchor": "herspawnanker",
}
export const li_li = items; 
